module.exports = __webpack_public_path__ + "img/overview_brand_03.11fee388.jpg";